/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * QuestionsProgressBase
 * auto generated base class for the model QuestionsProgressModel.
 */
export const QuestionsProgressModelBase = ModelBase.named('QuestionsProgress')
  .props({
    __typename: types.optional(types.literal('QuestionsProgress'), 'QuestionsProgress'),
    answeredQuestions: types.union(types.undefined, types.number),
    totalQuestions: types.union(types.undefined, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class QuestionsProgressModelSelector extends QueryBuilder {
  get answeredQuestions() {
    return this.__attr('answeredQuestions')
  }
  get totalQuestions() {
    return this.__attr('totalQuestions')
  }
}
export function selectFromQuestionsProgress() {
  return new QuestionsProgressModelSelector()
}

export const questionsProgressModelPrimitives = selectFromQuestionsProgress().answeredQuestions.totalQuestions
